var card_default = {
  "link": "h7-of",
  "container": "_9D7Wy",
  "cardLayout": "p2yGS",
  "imageEnd": "KsPZz",
  "imageStart": "yPfR2",
  "imageTop": "YqZJ-",
  "right": "M5HZ8",
  "ltr": "t36ue",
  "rtl": "y37WG",
  "imageContainer": "QB1X6",
  "image": "qj7Lr",
  "responsiveImage": "dacRA",
  "squareImage": "_92J-5",
  "rectangleImage": "_1vmQA",
  "squareRatio": "_4RM2i",
  "rectangleRatio": "g1IhY",
  "imageFill": "_49w0R",
  "imageFit": "A38-c",
  "imageRibbon": "Xuh8-"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
